<template>
  <div>
    <div class="security-option" v-if="!loading">
      <div class="wrapper">

        <div class="input-holder">
          <div class="header">
            <h3>Old Password</h3>
            <p v-if="error.oldPasswordError">Invalid input</p>
          </div>
          <input
            type="password"
            name="oldPassword"
            placeholder="Enter old password"
            v-model="formData.oldPassword"
            v-on:change="validateText"
          />
          <em v-if="error.oldPasswordError" class="password-hint">
            Hint: Enter a combination of letters, numbers, and
            special characters of not less than eight characters
          </em>
        </div>

        <div class="input-holder">
          <div class="header">
            <h3>New Password</h3>
            <p v-if="error.newPasswordError">Invalid input</p>
          </div>
          <input
            type="password"
            name="newPassword"
            placeholder="Enter new password"
            v-model="formData.newPassword"
            v-on:change="validateText"
          />
          <em class="password-hint">
            Hint: Enter a combination of letters, numbers, and
            special characters of not less than eight characters
          </em>
        </div>

        <div class="input-holder">
          <div class="header">
            <h3>Confirm Password</h3>
            <p v-if="error.confirmPasswordError">Password Mismatch</p>
          </div>
          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm new password"
            v-model="formData.confirmPassword"
            v-on:change="validateText"
          />
        </div>

        <div class="security-buttons">
          <button class="cancel-btn" @click="$emit('closePasswordSettings')">Cancel</button>
          <button class="update-btn" @click="handleSubmit()">Save</button>
        </div>

      </div>
    </div>

    <!-- Loader Component -->
    <div class="loader" v-if="loading">
      <loader />
    </div>

  </div>
</template>
<script>
import Loader from './Loader.vue';
export default {
  components: { Loader },
  name: 'PasswordChange',
  data() {
    return {
      formData: {
        oldPassword: null,
        newPassword: null,
        confirmPassword: null,
      },
      error: {
        oldPasswordError: false,
        newPasswordError: false,
        confirmPasswordError: false,
      },
      loading: false,
    };
  },
  methods: {
    validateText(e){
      const fieldName = e.target.name;
      const fieldValue = e.target.value;
      let passwordPattern = new RegExp('^(?=.*[a-z])(?=.*[0-9])(?=.{8,})');

      switch(fieldName){
        case 'oldPassword':
          if (!fieldValue.match(passwordPattern) && fieldValue !== '') {
            this.error.oldPasswordError = true;
          } else {
            this.error.oldPasswordError = false;
          }
          break;

        case 'newPassword':
          if (!fieldValue.match(passwordPattern) && fieldValue !== '') {
            this.error.newPasswordError = true;
          } else {
            this.error.newPasswordError = false;
          }
          break;

        case 'confirmPassword':
          this.formData.confirmPassword !== this.formData.newPassword ?
          this.error.confirmPasswordError = true : this.error.confirmPasswordError = false;
          break;
      }
    },
    handleSubmit(){
      if(
        !this.formData.oldPassword ||
        !this.formData.newPassword ||
        !this.formData.confirmPassword ||
        this.error.oldPasswordError ||
        this.error.newPasswordError ||
        this.error.confirmPasswordError
      ){
        Object.keys(this.formData).forEach((field) => {
          if (!this.formData[field]) {
            this.error[`${field}Error`] = true;
          }
        });
      } else {
        this.loading = true;
        let {oldPassword, newPassword} = this.formData;

        this.$store.dispatch('changePassword', {oldPassword, newPassword})
        .then((res) => {
          if(res.response){
            this.$toastr.success('Password Changed! Please login to continue', 'Success');
            this.loading = false;
            setTimeout(() => this.$emit('logout'), 2000);
          } else {
            this.$toastr.error(res.error, 'Error');
            this.loading = false;
          }
        });
      }
    }
  },
};

</script>
<style scoped>
  .security-option{
    background: var(--white);
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
    border-radius: 15px;
    margin-top: 40px;
    padding: 40px;
  }
  h3 {
    font-family: 'montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 1rem;
    line-height: 21.94px;
    color: var(--colorSecondary);
  }
  p {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #5B5B5B;
    margin-top: 17px;
  }
  .password-hint {
    color: #787878;
    font-size: 0.7rem;
  }
  em{
    padding-top: 10px;
  }
  input {
    width: 100%;
    height: 50px;
    box-shadow: 0px 0px 4px 2px rgba(39, 31, 31, 0.15);
    border-radius: 5px;
    outline: none;
    padding: 10px;
    font-family: montserrat;
    font-size: 1rem;
    color: rgba(51, 52, 54, 0.7);
    line-height: 1.25rem;
    -webkit-appearance: auto;
    color: rgba(51, 52, 54, 0.7);
    margin-top: 13px;
    margin-bottom: 10px;
  }
  .input-holder {
    margin-bottom: 40px;
  }
  .input-holder .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .input-holder .header p {
    font-size: 14px;
    color: tomato;
    margin-top: 0;
  }
  .security-buttons {
    display: flex;
    margin-top: 60px;
  }
  .security-buttons button {
    border-radius: 5px;
    padding: 15px 50px;
    font-weight: 800;
    min-width: 180px;
  }
  .security-buttons .update-btn {
    background: var(--colorPrimary);
    box-shadow: 0px 9px 29px rgba(26, 107, 158, 0.1);
    color: var(--white);
  }
  .security-buttons .cancel-btn {
    color: #252525;
    box-sizing: border-box;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.15);
    margin-right: 40px;
  }

  /* RESPONSIVENESS */
  @media only screen and (max-width: 565px) {
    .security-buttons {
      width: 100%;
      flex-direction: column;
      align-items: center;
    }
    .buttons button, .security-buttons button {
      width: 160px;
      margin: 10px 0 !important;
    }
    .buttons {
      margin: 0 auto;
      flex-direction: column;
      align-items: center;
    }
    .loader {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
      height: 100%;
      position: absolute;
    }
  }

  /* RESPONSIVENESS */
  @media only screen and (min-width: 1400px) {
    .security-option .wrapper {
      padding: 60px;
      width: 50%;
    }
  }
  @media only screen and (max-width: 1399px) {
    .security-option .wrapper {
      width: 70%;
    }
  }
  @media only screen and (max-width: 1080px) {
    .security-option .wrapper {
      padding: 60px 20px;
      width: 100%;
    }
  }
  @media only screen and (max-width: 480px) {
    .security-option {
      padding: 40px 20px;
    }
  }
</style>
